import { Icon, ValidIconName } from 'ehs-react';
import React from 'react';

export interface IAnnouncement {
  headingText: string;
  attentionText: string;
  image: string;
}

function AnnouncementComponent({
  announcement
}: {
  announcement: IAnnouncement;
}): JSX.Element {
  return (
    <>
      <p className="heading-text">{announcement.headingText}</p>
      <div className="icon-section">
        <div className="icon-section-container">
          <Icon
            iconName={announcement.image as ValidIconName}
            className="announcement-icon"
            aria-label={undefined}
          />
        </div>
      </div>
      <p className="attention-text">{announcement.attentionText}</p>
    </>
  );
}

export const Announcement = AnnouncementComponent;
